/* eslint-disable react-doctor/no-event-handler -- SSR-safe localStorage read must happen in useEffect after mount to avoid hydration mismatch */
/* eslint-disable react-doctor/no-derived-state -- storedValue cannot be computed during render because localStorage is unavailable on the server */
'use client';

import { useState, useEffect } from 'react';

export const useLocalStorage = <T>(key: string, initialValue: T): [T, (value: T) => void] => {
  const [storedValue, setStoredValue] = useState<T>(initialValue);

  // Read from localStorage only after mount to avoid SSR/client mismatch
  useEffect(() => {
    try {
      const item = window.localStorage.getItem(key);
      if (item !== null) setStoredValue(JSON.parse(item) as T);
    } catch {
      // ignore
    }
  }, [key]);

  const setValue = (value: T): void => {
    setStoredValue(value);
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // ignore
    }
  };

  return [storedValue, setValue];
};
